<div class="documents-container">
  <!-- Back button -->
  <button mat-icon-button (click)="goToDashboard()" aria-label="Go back to dashboard" class="back-button">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h2>My Documents</h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <!-- Search Bar -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Documents</mat-label>
        <input matInput [(ngModel)]="searchQuery" (input)="filterDocuments($any($event.target).value)"
               placeholder="Search by name, type, or category">
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>

      <!-- Loading Spinner -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>

      <!-- Documents Tabs -->
      <mat-tab-group *ngIf="!loading">
        <!-- Clinical Documents Tab -->
        <mat-tab label="Clinical Documents">
          <ng-template matTabContent>
            <div class="documents-section">
              <div *ngIf="filteredDocuments.length === 0" class="empty-state">
                <mat-icon>folder_open</mat-icon>
                <p>No clinical documents found</p>
              </div>

              <mat-table *ngIf="filteredDocuments.length > 0" [dataSource]="filteredDocuments"
                         class="documents-table mat-elevation-z2">

                <!-- Icon Column -->
                <ng-container matColumnDef="icon">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let doc">
                    <mat-icon class="document-icon" [color]="doc.isPdf ? 'warn' : 'primary'">
                      {{ getDocumentIcon(doc) }}
                    </mat-icon>
                  </mat-cell>
                </ng-container>

                <!-- File Name Column -->
                <ng-container matColumnDef="fileName">
                  <mat-header-cell *matHeaderCellDef>Document Name</mat-header-cell>
                  <mat-cell *matCellDef="let doc">
                    <div class="document-info">
                      <span class="file-name">{{ doc.fileName || doc.description }}</span>
                      <span class="file-size">{{ formatFileSize(doc.fileSize) }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <!-- Document Type Column -->
                <ng-container matColumnDef="documentType">
                  <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                  <mat-cell *matCellDef="let doc">
                    <mat-chip>
                      {{ doc.documentType || doc.category }}
                    </mat-chip>
                  </mat-cell>
                </ng-container>

                <!-- Upload Date Column -->
                <ng-container matColumnDef="uploadDate">
                  <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                  <mat-cell *matCellDef="let doc">
                    {{ formatDate(doc.uploadDate) }}
                  </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                  <mat-cell *matCellDef="let doc">
                    <!-- Only show view/download if downloadUrl is available -->
                    <ng-container *ngIf="doc.downloadUrl">
                      <button mat-icon-button (click)="viewDocument(doc)"
                              matTooltip="View Document" color="primary">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button mat-icon-button (click)="downloadDocument(doc)"
                              matTooltip="Download Document" color="accent">
                        <mat-icon>download</mat-icon>
                      </button>
                    </ng-container>
                    <!-- Show info text when download not available -->
                    <span *ngIf="!doc.downloadUrl" class="no-download-text">
                      Available at office
                    </span>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            </div>
          </ng-template>
        </mat-tab>

        <!-- Filled Forms Tab -->
        <mat-tab label="Completed Forms">
          <ng-template matTabContent>
            <div class="forms-section">
              <div *ngIf="filledForms.length === 0" class="empty-state">
                <mat-icon>assignment_turned_in</mat-icon>
                <p>No completed forms found</p>
              </div>

              <div class="form-grid" *ngIf="filledForms.length > 0">
                <mat-card *ngFor="let form of filledForms" class="form-card">
                  <mat-card-header>
                    <mat-icon mat-card-avatar color="primary">description</mat-icon>
                    <mat-card-title>{{ form.form_title }}</mat-card-title>
                    <mat-card-subtitle>
                      Completed: {{ formatDate(form.modified_at) }}
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="viewFormPdf(form)">
                      <mat-icon>picture_as_pdf</mat-icon>
                      View PDF
                    </button>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
